/**
 * YumCart — custom cart drawer
 * Phase 2: progress bar + bubble positioning + status text + rewards
 */
(function () {
  'use strict';

  // === If customer lands directly on /cart (typed URL, bookmark, external link),
  // bounce them to the homepage with YumCart auto-opened. /cart page is intentionally
  // unused — all cart UX flows through YumCart so customers see upsells, gifts, and
  // bundle discounts. For zero flash, also set up a server-side redirect in
  // Shopify admin → Online Store → Navigation → URL Redirects: /cart → /?yumcart=1
  if (location.pathname === '/cart' || location.pathname === '/cart/') {
    window.location.replace('/?yumcart=1');
    return;
  }

  var SECTION_ID = 'yum-cart-drawer';
  var drawer, overlay, body, subtotalEl, subtotalOrigEl, countEl,
      progressEl, statusMainEl, statusSubEl, fillEl, bubblesEl, rewardsEl, savingsEl;
  var isOpen = false;
  var initialized = false;
  var refreshing = false;

  function init() {
    if (initialized) return;
    drawer = document.getElementById('yum-cart-drawer');
    overlay = document.getElementById('yum-cart-overlay');
    if (!drawer || !overlay) {
      console.warn('[YumCart] drawer not found in DOM');
      return;
    }
    cacheRefs();

    var closeBtn = drawer.querySelector('[data-yc-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
    body.addEventListener('click', handleBodyClick);

    renderProgress();
    initialized = true;
    console.log('[YumCart] ready — call YumCart.open() to test');
    // Auto-add any free gifts whose threshold is already met from a prior cart session
    processAutoGifts();

    // URL trigger: ?yumcart=1 or #yumcart auto-opens the drawer (for mobile testing)
    var params = new URLSearchParams(window.location.search);
    if (params.get('yumcart') === '1' || window.location.hash === '#yumcart') {
      setTimeout(open, 50);
      if (window.history && window.history.replaceState) {
        params.delete('yumcart');
        var qs = params.toString();
        var clean = window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash === '#yumcart' ? '' : window.location.hash);
        window.history.replaceState({}, '', clean);
      }
    }
  }

  function cacheRefs() {
    body = drawer.querySelector('[data-yc-body]');
    subtotalEl = drawer.querySelector('[data-yc-subtotal]');
    subtotalOrigEl = drawer.querySelector('[data-yc-subtotal-orig]');
    countEl = drawer.querySelector('[data-yc-count]');
    progressEl = drawer.querySelector('[data-yc-progress]');
    statusMainEl = drawer.querySelector('[data-yc-status-main]');
    statusSubEl = drawer.querySelector('[data-yc-status-sub]');
    fillEl = drawer.querySelector('[data-yc-progress-fill]');
    bubblesEl = drawer.querySelector('[data-yc-progress-bubbles]');
    rewardsEl = drawer.querySelector('[data-yc-rewards]');
    savingsEl = drawer.querySelector('[data-yc-savings]');
  }

  function open() {
    if (!initialized) init();
    if (!drawer || isOpen) return;
    isOpen = true;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('yum-cart-open');
    refresh();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yum-cart-open');
    // Notify other components (e.g., bundle progress bar) so they can re-sync with cart state
    try { document.dispatchEvent(new CustomEvent('yumcart:closed', { bubbles: true })); } catch (e) {}
  }

  function refresh() {
    if (refreshing) return Promise.resolve();
    refreshing = true;
    return fetch('/?section_id=' + SECTION_ID + '&_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { if (!r.ok) throw new Error('section fetch ' + r.status); return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        // Copy data attributes from the new drawer root
        var newDrawer = temp.querySelector('#yum-cart-drawer');
        if (newDrawer) {
          ['ycCartTotalCents','ycOriginalTotalCents','ycTotalDiscountCents','ycTotalSavingsCents','ycItemCount'].forEach(function (k) {
            if (newDrawer.dataset[k] !== undefined) drawer.dataset[k] = newDrawer.dataset[k];
          });
        }
        var newBody = temp.querySelector('[data-yc-body]');
        if (newBody && body) body.innerHTML = newBody.innerHTML;
        var newCount = temp.querySelector('[data-yc-count]');
        if (newCount && countEl) countEl.textContent = newCount.textContent.trim();
        var newSubtotal = temp.querySelector('[data-yc-subtotal]');
        if (newSubtotal && subtotalEl) subtotalEl.textContent = newSubtotal.textContent.trim();
        var newSubtotalOrig = temp.querySelector('[data-yc-subtotal-orig]');
        if (subtotalOrigEl) {
          if (newSubtotalOrig && !newSubtotalOrig.hasAttribute('hidden') && newSubtotalOrig.textContent.trim()) {
            subtotalOrigEl.textContent = newSubtotalOrig.textContent.trim();
            subtotalOrigEl.removeAttribute('hidden');
          } else {
            subtotalOrigEl.setAttribute('hidden', '');
          }
        }
        var newSavings = temp.querySelector('[data-yc-savings]');
        if (newSavings && savingsEl) savingsEl.textContent = newSavings.textContent.trim();
        // Replace the entire shipping block (S/H row + nudge) — its state depends on cart
        // total vs. free shipping threshold, so it has to re-render on every cart change.
        var newShipBlock = temp.querySelector('[data-yc-shipping-block]');
        var currentShipBlock = drawer.querySelector('[data-yc-shipping-block]');
        if (newShipBlock && currentShipBlock) {
          currentShipBlock.innerHTML = newShipBlock.innerHTML;
        }
        // Also refresh the auto-gift config in case settings changed
        var newAutoGifts = temp.querySelector('[data-yc-auto-gifts]');
        var currentAutoGifts = drawer.querySelector('[data-yc-auto-gifts]');
        if (newAutoGifts && currentAutoGifts) currentAutoGifts.textContent = newAutoGifts.textContent;
        renderProgress();
        processAutoGifts();
      })
      .catch(function (err) { console.warn('[YumCart] refresh failed', err); })
      .then(function () { refreshing = false; });
  }

  function renderProgress() {
    // Re-query refs every call — progress bar lives inside the body which gets
    // wholesale-replaced on refresh, so cached references go stale.
    progressEl = drawer.querySelector('[data-yc-progress]');
    bubblesEl = drawer.querySelector('[data-yc-progress-bubbles]');
    fillEl = drawer.querySelector('[data-yc-progress-fill]');
    rewardsEl = drawer.querySelector('[data-yc-rewards]');
    if (!progressEl || !bubblesEl || !fillEl) return;
    var bubbles = bubblesEl.querySelectorAll('[data-yc-tier]');
    var n = bubbles.length;
    if (!n) return;

    var cartCents = parseInt(drawer.dataset.ycCartTotalCents || '0', 10);
    var cartDollars = cartCents / 100;
    var discountCents = parseInt(drawer.dataset.ycTotalDiscountCents || '0', 10);
    // Total savings = compare-at gap + Shopify discounts (set server-side by drawer Liquid).
    var totalSavingsCents = parseInt(drawer.dataset.ycTotalSavingsCents || discountCents, 10);

    var tiers = Array.prototype.map.call(bubbles, function (b) {
      return { el: b, threshold: parseFloat(b.dataset.ycTierThreshold || '0') };
    });

    // Evenly space the milestone dots, inset from both edges (clean ladder look).
    var PAD = 18; // % inset from each edge
    tiers.forEach(function (t, i) {
      t.position = (n === 1) ? 50 : PAD + (i * (100 - 2 * PAD)) / (n - 1);
      t.el.style.left = t.position + '%';
      t.el.classList.toggle('is-hit', cartDollars >= t.threshold);
    });

    // Fill: from the left edge through each dot as its threshold is crossed; 100% once all met.
    var fillPct = 0;
    if (cartDollars > 0) {
      if (cartDollars >= tiers[n - 1].threshold) {
        fillPct = 100;
      } else {
        var prevPos = 0, prevThresh = 0;
        for (var i = 0; i < n; i++) {
          if (cartDollars < tiers[i].threshold) {
            var span = tiers[i].threshold - prevThresh;
            var frac = span > 0 ? (cartDollars - prevThresh) / span : 0;
            fillPct = prevPos + frac * (tiers[i].position - prevPos);
            break;
          }
          prevPos = tiers[i].position;
          prevThresh = tiers[i].threshold;
        }
      }
    }
    fillEl.style.width = Math.max(0, Math.min(100, fillPct)) + '%';

    // Rewards/savings line visibility (independent of the bar; no emoji/perk badge).
    var savingsLineEl = drawer.querySelector('[data-yc-savings-line]');
    var hasSavings = totalSavingsCents > 0;
    if (savingsLineEl) {
      if (hasSavings) savingsLineEl.removeAttribute('hidden');
      else savingsLineEl.setAttribute('hidden', '');
    }
    if (rewardsEl) {
      if (hasSavings) rewardsEl.removeAttribute('hidden');
      else rewardsEl.setAttribute('hidden', '');
    }
  }

  // Auto-add/remove free gifts when cart crosses each gift's threshold.
  // Runs after every drawer refresh. Idempotent: if cart >= threshold and gift in cart, no-op.
  // The ycAutoGiftBusy flag prevents infinite refresh loops while ops are in flight.
  var ycAutoGiftBusy = false;
  function processAutoGifts() {
    if (ycAutoGiftBusy) return;
    var configEl = drawer.querySelector('[data-yc-auto-gifts]');
    if (!configEl) return;
    var configs;
    try { configs = JSON.parse(configEl.textContent || '[]'); } catch (e) { return; }
    if (!configs || !configs.length) return;

    ycAutoGiftBusy = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartCents = cart.total_price;
        var inCart = {};
        cart.items.forEach(function (it) { inCart[String(it.variant_id)] = it.key; });

        var ops = [];
        configs.forEach(function (g) {
          var vid = String(g.variantId);
          var minCents = (g.minCart || 0) * 100;
          var lineKey = inCart[vid];
          if (cartCents >= minCents && !lineKey) {
            ops.push({ type: 'add', variantId: g.variantId });
          } else if (cartCents < minCents && lineKey) {
            ops.push({ type: 'remove', key: lineKey });
          }
        });

        if (ops.length === 0) {
          ycAutoGiftBusy = false;
          return;
        }

        // Process ops serially via _yc_skip flag so we don't fire the toast on each
        var chain = Promise.resolve();
        ops.forEach(function (op) {
          chain = chain.then(function () {
            if (op.type === 'add') {
              return fetch('/cart/add.js?_yc_skip=1', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: op.variantId, quantity: 1 })
              });
            }
            return fetch('/cart/change.js?_yc_skip=1', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: op.key, quantity: 0 })
            });
          });
        });

        return chain.then(function () {
          ycAutoGiftBusy = false;
          // Re-refresh drawer to reflect the new cart state (added/removed gifts).
          // Second pass of processAutoGifts will be a no-op since state is now in sync.
          return refresh();
        });
      })
      .catch(function () { ycAutoGiftBusy = false; });
  }

  function handleBodyClick(e) {
    // Remove (X) button on locked-qty promo/upsell line items
    var removeBtn = e.target.closest('[data-yc-remove]');
    if (removeBtn) {
      e.preventDefault();
      var rmItem = e.target.closest('[data-yc-item]');
      if (!rmItem) return;
      var rmKey = rmItem.dataset.ycKey;
      removeBtn.disabled = true;
      changeLineItem(rmKey, 0);
      return;
    }

    // Line item qty +/-
    var decBtn = e.target.closest('[data-yc-qty-decrement]');
    var incBtn = e.target.closest('[data-yc-qty-increment]');
    if (decBtn || incBtn) {
      e.preventDefault();
      var item = e.target.closest('[data-yc-item]');
      if (!item) return;
      var lineKey = item.dataset.ycKey;
      var currentQty = parseInt(item.querySelector('[data-yc-qty-value]').textContent, 10) || 0;
      var newQty = decBtn ? Math.max(0, currentQty - 1) : currentQty + 1;
      if (newQty === currentQty) return;
      var btns = item.querySelectorAll('[data-yc-qty-decrement], [data-yc-qty-increment]');
      btns.forEach(function (b) { b.disabled = true; });
      changeLineItem(lineKey, newQty).then(function () { btns.forEach(function (b) { b.disabled = false; }); });
      return;
    }

    // Upsell "Add to Cart"
    var upsellBtn = e.target.closest('[data-yc-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      var variantId = parseInt(upsellBtn.dataset.ycUpsellVariantId, 10);
      if (!variantId) return;
      var origLabel = upsellBtn.textContent;
      upsellBtn.disabled = true;
      upsellBtn.textContent = 'Adding…';
      addToCart(variantId, 1).then(function (ok) {
        if (!ok) {
          upsellBtn.disabled = false;
          upsellBtn.textContent = origLabel;
        }
        // On success, refresh redraws the drawer and the upsell card is removed because the item is now in cart
      });
    }
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart add ' + r.status);
        return r.json();
      })
      .then(function () { return refresh(); })
      .then(function () { return true; })
      .catch(function (err) { console.warn('[YumCart] upsell add failed', err); return false; });
  }

  function changeLineItem(lineKey, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart change ' + r.status); return r.json(); })
      .then(function () { return refresh(); })
      .catch(function (err) { console.warn('[YumCart] qty change failed', err); });
  }

  window.YumCart = {
    open: open,
    close: close,
    refresh: refresh,
    isOpen: function () { return isOpen; },
    processAutoGifts: processAutoGifts
  };

  // === Stage 5a cutover: intercept ALL cart-icon clicks and open YumCart instead.
  // Runs in capture phase so it fires before iCart's own click handlers and can fully
  // block them via stopImmediatePropagation. Safe to leave running even if iCart is
  // still installed — clicks just route to YumCart now.
  var CART_TRIGGER_SELECTORS = [
    // YumCart's own floating action button
    '[data-yc-fab]',
    '#yum-cart-fab',
    // iCart (real class names from this store: capital "iCart" prefix on action buttons)
    '.iCartBtnToggle',
    '.icart-count-bubble',
    '#icartCount',
    '#icartCountBubble',
    '.icart-cart-link',
    '.icart-floating-cart',
    '.icart-cart-bubble',
    '.icart-cart-toggle',
    '.icart-mini-cart-toggle',
    '.icart-cart-icon',
    '[class^="icart-floating"]',
    // Generic theme conventions
    '[data-cart-toggle]',
    '[data-cart-trigger]',
    '[data-action="open-cart"]',
    '.js-drawer-open-cart',
    '.js-cart-drawer-open',
    // Ella + common Shopify theme classes
    '.header__cart',
    '.header__cart-link',
    '.header__cart-icon',
    '.header-cart',
    '.header__action--cart',
    '.header__top-action--cart',
    '.site-cart',
    '.action-link-cart',
    '.header-action__cart',
    '.cart-icon',
    '.cart-link',
    '.cart-toggle',
    '.cart-count-bubble',
    '.cart-amount',
    // Direct /cart links
    'a[href="/cart"]',
    'a[href^="/cart?"]',
    'a[href$="/cart"]'
  ].join(',');

  document.addEventListener('click', function (e) {
    // Never intercept clicks inside the YumCart drawer itself
    if (e.target && e.target.closest && e.target.closest('#yum-cart-drawer, #yum-cart-overlay')) return;
    var trigger = e.target && e.target.closest ? e.target.closest(CART_TRIGGER_SELECTORS) : null;
    if (!trigger) return;
    // Don't hijack add-to-cart, remove, or checkout buttons that happen to live inside a cart trigger ancestor
    if (e.target.closest('[name="add"], [data-add-to-cart], [data-cart-remove], [name="checkout"], .yum-cart-drawer__checkout')) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open();
  }, true);

  // === Stage 5c: intercept all product-form add-to-cart triggers site-wide.
  // Three vectors covered:
  //   1. submit event (normal form submission, Enter key)
  //   2. click on submit button (catches themes that intercept the click and call form.submit() — that path skips the submit event per HTML spec)
  //   3. programmatic form.submit() (prototype override catches any other JS path)
  // All three route to the same AJAX flow → toast + cart icon bump, no /cart navigation.
  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.id === 'yum-cart-form') return false;
    var action = (form.action || '').toLowerCase();
    return /\/cart\/add(\.js)?(\/)?(\?|$)/.test(action);
  }

  var ycSubmitInProgress = new WeakSet();
  function ycSubmitCartForm(form) {
    if (ycSubmitInProgress.has(form)) return; // avoid double-fire across vectors
    ycSubmitInProgress.add(form);

    var submitBtn = form.querySelector('[type="submit"], [name="add"]');
    var origLabel = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.ycOrigLabel = origLabel || '';
      if (submitBtn.textContent && /add/i.test(submitBtn.textContent)) submitBtn.textContent = 'Adding…';
    }

    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
      .then(function (result) {
        if (submitBtn) {
          submitBtn.disabled = false;
          if (submitBtn.dataset.ycOrigLabel) submitBtn.textContent = submitBtn.dataset.ycOrigLabel;
        }
        ycSubmitInProgress.delete(form);
        if (!result.ok || (result.body && result.body.status && result.body.status >= 400)) {
          var msg = (result.body && (result.body.description || result.body.message)) || 'Add to cart failed';
          console.warn('[YumCart] add failed:', msg);
          alert(msg);
          return;
        }
        // Success — toast + icon bump fires automatically via the fetch hook on /cart/add.js.
      })
      .catch(function (err) {
        console.warn('[YumCart] form intercept error', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          if (submitBtn.dataset.ycOrigLabel) submitBtn.textContent = submitBtn.dataset.ycOrigLabel;
        }
        ycSubmitInProgress.delete(form);
      });
  }

  // Vector 1: submit event
  document.addEventListener('submit', function (e) {
    if (!isCartAddForm(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    ycSubmitCartForm(e.target);
  }, true);

  // Vector 2: click on submit button inside a cart-add form
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[type="submit"], [name="add"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!isCartAddForm(form)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    ycSubmitCartForm(form);
  }, true);

  // Vector 3: programmatic form.submit() — does NOT fire submit event per HTML spec
  if (HTMLFormElement && HTMLFormElement.prototype && HTMLFormElement.prototype.submit) {
    var ycOrigFormSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (isCartAddForm(this)) {
        ycSubmitCartForm(this);
        return;
      }
      return ycOrigFormSubmit.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =============================================================================
 * Add-to-cart feedback (cart icon bump + toast notification)
 * Intercepts any /cart/add request from anywhere on the site and shows a subtle
 * confirmation instead of opening the drawer. Skips when YumCart is already
 * open (the new line item is already visible to the user).
 * ============================================================================= */
(function () {
  'use strict';

  var ADD_PATH_RE = /\/cart\/add(\.js)?(\?|$)/;
  var MUTATION_PATH_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var pending = false;

  // --- Hook window.fetch
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var promise = origFetch.apply(this, arguments);
      if (method === 'POST' && MUTATION_PATH_RE.test(url)) {
        var skipToast = url.indexOf('_yc_skip=1') !== -1;
        var isAdd = ADD_PATH_RE.test(url);
        promise.then(function (resp) {
          if (resp && resp.ok) scheduleFeedback({ toast: isAdd && !skipToast });
        }).catch(function () {});
      }
      return promise;
    };
  }

  // --- Hook XMLHttpRequest (covers jQuery $.ajax and other legacy code paths)
  var XHRProto = XMLHttpRequest.prototype;
  var origOpen = XHRProto.open;
  var origSend = XHRProto.send;
  XHRProto.open = function (method, url) {
    this._ycAddUrl = url || '';
    this._ycAddMethod = (method || '').toUpperCase();
    return origOpen.apply(this, arguments);
  };
  XHRProto.send = function () {
    var self = this;
    if (this._ycAddMethod === 'POST' && MUTATION_PATH_RE.test(this._ycAddUrl)) {
      var skipToast = this._ycAddUrl.indexOf('_yc_skip=1') !== -1;
      var isAdd = ADD_PATH_RE.test(this._ycAddUrl);
      this.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) scheduleFeedback({ toast: isAdd && !skipToast });
      });
    }
    return origSend.apply(this, arguments);
  };

  function scheduleFeedback(opts) {
    opts = opts || {};
    // Skip toast if YumCart drawer is already open (line item is visible there).
    var showToastFlag = opts.toast && !(window.YumCart && window.YumCart.isOpen && window.YumCart.isOpen());
    if (pending) {
      // upgrade: if a toast wants to fire on top of a pending count-update, queue it
      if (showToastFlag) pending = 'toast';
      return;
    }
    pending = showToastFlag ? 'toast' : true;
    setTimeout(function () {
      var withToast = pending === 'toast';
      pending = false;
      fireFeedback(withToast);
    }, 80);
  }

  // Track last-known cart count so we can fire the FAB pop animation only when it INCREASES
  // (avoids extra animations on decrement/clear which shouldn't celebrate).
  var lastKnownCount = null;

  function fireFeedback(withToast) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prev = lastKnownCount;
        updateCartCount(cart.item_count);
        bumpCartIcon();
        // FAB pop animation when an item was added (count went up)
        if (prev !== null && cart.item_count > prev) popCartFab();
        lastKnownCount = cart.item_count;
        if (withToast) showToast('Added to cart');
        // Auto-add/remove gifts globally — fires even when drawer is closed, so customer
        // never misses out on a free gift by forgetting to open the cart.
        if (window.YumCart && window.YumCart.processAutoGifts) window.YumCart.processAutoGifts();
      })
      .catch(function () {
        if (withToast) showToast('Added to cart');
      });
  }

  function updateCartCount(count) {
    var sels = [
      '[data-cart-count]',
      '.cart-count',
      '.header-cart-count',
      '.cart-link__bubble-num',
      '.cart-count-bubble span',
      '.site-cart-count',
      '.Header__CartCount',
      '#CartCount',
      '.header__cart-count',
      '.cart_count_number',
      '.minicart-count',
      '[data-yc-fab-count]'
    ];
    sels.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) {
        els[i].textContent = count;
      }
    });
    // Toggle the FAB's empty-state attribute so the count badge hides at 0
    var fab = document.getElementById('yum-cart-fab');
    if (fab) {
      if (count > 0) fab.removeAttribute('data-yc-empty');
      else fab.setAttribute('data-yc-empty', '');
    }
  }

  function popCartFab() {
    var fab = document.getElementById('yum-cart-fab');
    if (!fab) return;
    fab.classList.remove('is-pop');
    // Force reflow so re-adding the class restarts the animation
    void fab.offsetWidth;
    fab.classList.add('is-pop');
    setTimeout(function () { fab.classList.remove('is-pop'); }, 700);
  }

  // Initialize lastKnownCount from /cart.js on first load so the FAB doesn't pop on page refresh
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) { lastKnownCount = cart.item_count; })
    .catch(function () {});

  function bumpCartIcon() {
    var sels = [
      '[data-cart-count]',
      '.cart-count',
      '.header-cart',
      '.header__icon-cart',
      '.cart-link',
      '.cart-toggle',
      '.site-cart',
      '.cart-icon',
      '.header__cart',
      '.cart-count-bubble',
      '.icart-cart-link',
      '.icart-cart-bubble'
    ];
    var seen = [];
    sels.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) {
        if (seen.indexOf(els[i]) === -1) seen.push(els[i]);
      }
    });
    seen.forEach(function (el) {
      el.classList.add('yum-cart-icon-bump');
      setTimeout(function () { el.classList.remove('yum-cart-icon-bump'); }, 500);
    });
  }

  function showToast(msg) {
    var existing = document.getElementById('yum-cart-toast');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var t = document.createElement('div');
    t.id = 'yum-cart-toast';
    t.className = 'yum-cart-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M16 6L8 14L4 10" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + msg + '</span>';
    document.body.appendChild(t);
    // Use setTimeout (not requestAnimationFrame) to apply is-visible — RAF callbacks are
    // unreliable on heavy theme pages where the browser throttles them. 20ms is enough
    // for the browser to register the initial pre-transition state.
    setTimeout(function () { t.classList.add('is-visible'); }, 20);
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
    }, 2000);
  }
})();



/* =============================================================================
 * Accessibility: cart drawer keyboard focus management (WCAG 2.1.2, 2.4.3, 2.4.7)
 * Additive enhancement. Watches the drawer's is-open state via MutationObserver so
 * it catches every open/close path. On open: remember the trigger, move focus into
 * the drawer, trap Tab inside it. On close: release the trap and return focus to
 * whatever opened it. Also injects a visible keyboard focus ring on drawer + FAB.
 * ============================================================================= */
(function () {
  'use strict';
  var drawer = null, lastFocused = null;
  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function injectStyle() {
    if (document.getElementById('yum-cart-a11y-focus-style')) return;
    var s = document.createElement('style');
    s.id = 'yum-cart-a11y-focus-style';
    s.textContent = '#yum-cart-drawer :focus-visible, #yum-cart-fab :focus-visible, [data-yc-fab] :focus-visible { outline: 3px solid #1a5fb4; outline-offset: 2px; border-radius: 4px; }';
    document.head.appendChild(s);
  }

  function focusables() {
    if (!drawer) return [];
    return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }

  function onKeydown(e) {
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function onOpen() {
    lastFocused = document.activeElement;
    document.addEventListener('keydown', onKeydown, true);
    var target = drawer.querySelector('[data-yc-close]') || focusables()[0];
    if (target) setTimeout(function () { try { target.focus(); } catch (e) {} }, 40);
  }

  function onClose() {
    document.removeEventListener('keydown', onKeydown, true);
    var el = lastFocused;
    if (el && document.contains(el)) { try { el.focus(); } catch (e) {} return; }
    var fab = document.getElementById('yum-cart-fab');
    if (fab) { var b = fab.querySelector('button, a, [tabindex]') || fab; try { b.focus(); } catch (e) {} }
  }

  function watch() {
    injectStyle();
    drawer = document.getElementById('yum-cart-drawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('is-open');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('is-open');
      if (isOpen && !wasOpen) onOpen();
      else if (!isOpen && wasOpen) onClose();
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
